import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=023bbd4d&"
import script from "./UserInfo.vue?vue&type=script&lang=babel&"
export * from "./UserInfo.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports